import React, { Component } from "react";

import "./InfoElement.css";

class InfoElement extends Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        let { value: prevValue } = this.state;
        let { value: newValue } = this.props;
        if (!newValue || !prevValue) {
            return;
        }
        if (newValue != prevValue) {
            this.setState({ value: newValue });
        }
    }
    state = {
        name: this.props.name,
        value: this.props.value || "نامشخص",
        editMode: false,
    };

    render() {
        let { name, value, editMode } = this.state;
        let { _key, on_edit, Component, type } = this.props;
        let newValue = "";
        const onChange = (ev) => {
            newValue = ev.target.value;
        };

        return (
            <div className='InfoElement'>
                <div className='caption'>{name}</div>
                <div className='value'>{value}</div>
                {editMode ? (
                    <div className='editMode'>
                        <Component
                            type={type}
                            value={value}
                            onChange={onChange}
                            key={name}
                        />

                        <button
                            className='save btn confirm'
                            onClick={(ev) => {
                                this.setState({ editMode: false });
                                on_edit(_key, newValue);
                            }}
                        >
                            ذخیره
                        </button>

                        <button
                            className='discard btn danger'
                            onClick={(ev) => {
                                this.setState({ editMode: false });
                            }}
                        >
                            لغو
                        </button>
                    </div>
                ) : (
                    _key !== "mobile" && (
                        <div
                            className='edit'
                            onClick={(ev) => {
                                this.setState({ editMode: true });
                            }}
                        >
                            ویرایش
                        </div>
                    )
                )}
            </div>
        );
    }
}

export default InfoElement;
